import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconFileCopy } from '@dsg-tech/homefield-angular-icons';

import { AccordionModule } from '@shared/components';
import { AvailableOffersComponent } from './available-offers.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { HomefieldButtonModule } from '@homefield';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		AvailableOffersComponent
	],
	exports: [
		AvailableOffersComponent
	],
	imports: [
		AccordionModule,
		ClipboardModule,
		CommonModule,
		HomefieldButtonModule,
		HomefieldIconLibraryModule
	]
})
export class AvailableOffersModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconFileCopy]);
	}
}
